import React, { useCallback } from 'react'
import { useTranslate } from 'ra-core';
import { usePermissions } from 'react-admin';
import { useDropzone } from 'react-dropzone';
import { useUploader } from './Uploader';
import BackupIcon from '@material-ui/icons/Backup';
import { useUploaderAddDialog } from './uploader-add-dialog/UploaderAddDialogProvider';


const UploaderDragAndDrop = (props) => {
    const { children } = props;
    const translate = useTranslate();
    const { permissions } = usePermissions();

    const uploader = useUploader();
    const { open: openUploaderAddDialog } = useUploaderAddDialog();
    const handleDrop = (files) => {
        openUploaderAddDialog(files);
    }

    const onDrop = useCallback(acceptedFiles => { handleDrop(acceptedFiles) }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({noClick: true, noKeyboard: true, onDrop})

    const handleOnClick = (event) => {
        event.target.value = null;
    }

    const handleOnChange = (event) => {
        const files = Array.from(event.target.files);
        for (let file of files)  {
            file.path = file?.webkitRelativePath ? file.webkitRelativePath : file.name;
        }
        openUploaderAddDialog(files);
    }

    
    if (!permissions?.has('upload-files')) {
        return <>{children}</>;
    }
    return (
        <div
            {...getRootProps()}
            style={{display: 'block', position: 'relative'}}
        >
            <input {...getInputProps()} onChange={handleOnChange} onClick={handleOnClick} webkitdirectory="" mozdirectory="" directory="" ref={uploader.uploadDirectoryInputRef} />
            <input {...getInputProps()} onChange={handleOnChange} onClick={handleOnClick} ref={uploader.uploadFileInputRef} />
            {
                isDragActive &&
                <div 
                    style={{
                        border: 'dashed rgb(224, 224, 224) 4px',
                        borderRadius: '5px',
                        backgroundColor: 'rgba(255,255,255)',
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0, 
                        right: 0,
                        zIndex: 9999
                    }}
                >
                    <div 
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            width: '100%',
                            height: '100%',
                            textAlign: 'center',
                            fontSize: '22px',
                            lineHeight: '22px',
                            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                            fontWeight: 400,
                            color: 'rgba(0, 0, 0, 0.54)',
                        }}
                    >
                        <BackupIcon/>&nbsp;<span>{translate(`cmss.components.drag-and-drop.upload`)}</span>
                    </div>
                </div>
            } 
            <>{children}</>
        </div>
    );
}
export default UploaderDragAndDrop
